export const IkonsMark = ({ className = "h-8" }) => (
  <img
    src="/images/ikons-logo.png"
    alt="IKONS by Solocracks"
    className={`w-auto ${className}`}
  />
);
